import React from 'react';
import { styles } from './preferences-styles';
import { CheckCircle } from '@material-ui/icons';
import { RadioButtonUnchecked } from '@material-ui/icons';

const RadioButton: React.FC<RadioButtonProps> = (props): JSX.Element => {
  const classes = styles();
  const { isSelected } = props;

  return isSelected ? (
    <CheckCircle className={classes.cashierPreferencesOptionRadioButtonIcon} />
  ) : (
    <RadioButtonUnchecked className={classes.cashierPreferencesOptionRadioButtonIcon} />
  );
};

interface RadioButtonProps {
  isSelected: boolean;
}

export default RadioButton;
